function adjustYPositionForStickyHeader (elementHash) {
  const headerHeight = $('header').outerHeight();

  $('html, body').animate({
    scrollTop: $(elementHash).offset().top - headerHeight
  }, 250);
}

(function($){
  if (window.location.hash) {
    setTimeout(function () {
      adjustYPositionForStickyHeader(window.location.hash);
    }, 0);
  }
})(jQuery);

$('.jump-link').on('click', function (e) {
  e.preventDefault();
  const hrefVal = $(this).attr('href');
  adjustYPositionForStickyHeader(hrefVal);
});

$('main a:not([data-toggle="tab"]):not(".js-reset"):not(".dt")').on('click', function (e) {
  e.preventDefault();
  const thisUrl = $(this)[0].href,
        urlHasHash = thisUrl.indexOf('#') > 0,
        thisHref = $(this).attr('href'),
        hashExists = thisHref.split('#')[1],
        hashString = '#' + hashExists;

  // check if internal link; external links are handled separately in `leave-site-notice.js`
  if(location.hostname === this.hostname || !this.hostname.length) {
    if(urlHasHash) {
      const thisUrlNoHash = thisUrl.split('#')[0];
      const locationHrefNoHash = location.href.split('#')[0];

      // check if same page
      if (thisUrlNoHash === locationHrefNoHash) {
        adjustYPositionForStickyHeader(hashString);
      } else {
        window.location = thisUrl;
      }
    } else {
      window.location = thisUrl;
    }
  }
});
